<template>
  <div class="help-center">
    <h3 class="help-center__title">Help Center</h3>
    <p class="help-center__desc">
      Please refer solution emails to ask your question.
    </p>
    <a-row :gutter="[24, 24]">
      <a-col :span="8">
        <HelpCard
          :icon="CreditCardIcon"
          title="Property and billing issues"
          desc="Find incorrect billing or want
        to link more properties with your project."
          email="customers+billing@allumeenergy.com.au"
        />
      </a-col>
      <a-col :span="8">
        <HelpCard
          :icon="LightBulbIcon"
          title="Suggestions and bug reports"
          desc="Find existing feature
        suggestions and bug reports."
          email="customers+bug@allumeenergy.com.au"
        />
      </a-col>
      <a-col :span="8">
        <HelpCard
          :icon="MessagesIcon"
          title="General enquiry"
          desc="Other questions."
          email="customers@allumeenergy.com.au"
        />
      </a-col>
    </a-row>
  </div>
</template>

<script setup>
import HelpCard from '../components/HelpCard.vue';
import LightBulbIcon from '../assets/icon/ic_lightbulb.svg?url';
import CreditCardIcon from '../assets/icon/ic_credit-cards.svg?url';
import MessagesIcon from '../assets/icon/ic_messages.svg?url';
</script>

<style lang="less" scoped>
.help-center {
  &__title,
  &__desc {
    text-align: center;
  }

  &__title {
    font-size: 21px;
    margin-top: 50px;
  }

  &__desc {
    margin-bottom: 40px;
    font-size: 17px;
  }
}
</style>
